// ActionsStatus.jsx
import { useContext, useEffect, useRef, useState } from "react";
import "./ActionsStatus.css";
import { Context } from "../../../../context/Context";
import { translations } from "../../../../utils/lang";
import { fetchActionsSummaryAPI } from "../../../../utils/api/actions";
import { ACTION_STATUSES } from "../../operationUtils";

export default function ActionsStatus({ storeId, appName, refreshKey }) {
  const { lang, handleTokenExpiration } = useContext(Context);

  const [summary, setSummary] = useState({});
  const [failed, setFailed] = useState(false);
  const tokenExpiredRef = useRef(handleTokenExpiration);
  tokenExpiredRef.current = handleTokenExpiration;

  useEffect(() => {
    let active = true;
    const token = localStorage.getItem("auth-token");
    if (!token) {
      tokenExpiredRef.current();
      return undefined;
    }

    fetchActionsSummaryAPI(token, { storeId, appName }).then((res) => {
      if (!active) return;
      // The helper resolves to undefined when the request failed.
      setFailed(!res);
      setSummary(res || {});
    });

    return () => {
      active = false;
    };
  }, [storeId, appName, refreshKey]);

  const statusText = translations[lang].Operation.status;

  return (
    <div className="actions-status-container">
      <h4 className="operation-card-section-title">
        {translations[lang].Operation.statusOverview}
      </h4>

      {failed ? (
        <p className="actions-status-unavailable" role="status">
          {lang === "ar" ? "غير متاح" : "Unavailable"}
        </p>
      ) : (
        // Fixed order; each count is labelled, not identified by colour alone.
        <ul className="actions-status-list">
          {ACTION_STATUSES.map((status) => (
            <li
              key={status}
              className={`actions-status-item action-${status}`}
              title={statusText[status]}
            >
              <span className="actions-status-visually-hidden">
                {statusText[status]}:{" "}
              </span>
              <span className="actions-status-count">{summary[status] ?? 0}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
